import axios from "axios";
import {getCustomerUrl} from "~/utils/customer-util";
import {StatusCodes} from "http-status-codes";
import type {ApiKeyInfo, ApiKeyUpdateRequest} from "~/types/api-key-type.ts";

export default class ApiKeyService {

    static async fetchApiKey(cNum: string, serverBase: string): Promise<ApiKeyInfo | null> {
        const url = getCustomerUrl(cNum, `${serverBase}/erp/api-key`);
        const resp = await axios.get(url);
        return resp.status === StatusCodes.NO_CONTENT ? null : resp.data;
    }

    static async updateApiKey(cNum: string, serverBase: string, data: ApiKeyUpdateRequest): Promise<ApiKeyInfo | null> {
        const url = getCustomerUrl(cNum, `${serverBase}/erp/api-key`);
        const resp = await axios.put(url, data);
        return resp.status === StatusCodes.NO_CONTENT ? null : resp.data;
    }
}
